import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';

@Injectable()
export class ServiceGuard {

  redirectUrl: string;

  constructor() { }

  authJsonHeaders() {
    const header = new Headers();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('Accept', 'application/json');
    header.append('Authorization', sessionStorage.getItem('bearer_token'));
    header.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    header.append('Pragma', 'no-cache');
    header.append('Expires', '0');
    return header;
  }


  authFormHeaders() {
    const header = new Headers();
    header.append('Content-Type', 'application/x-www-form-urlencoded');
    header.append('Accept', 'application/json');
    header.append('Access-Control-Allow-Origin', '*');
    header.append('Access-Control-Allow-Methods', 'GET,POST,DELETE,PUT,OPTIONS,HEAD');
    header.append('Authorization', sessionStorage.getItem('bearer_token'));
    header.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    header.append('Pragma', 'no-cache');
    header.append('Expires', '0');
    return header;
  }

  authTokenHeaders() {
    const header = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return header;
  }

  jsonHeaders() {
    const header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('Accept', 'application/json');
    header.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    header.append('Pragma', 'no-cache');
    header.append('Expires', '0');
    return header;
  }


  contentHeaders() {
    const header = new Headers();
    header.append('Content-Type', 'application/x-www-form-urlencoded');
    header.append('Access-Control-Allow-Origin', '*');
    header.append('Accept', 'application/json');
    return header;
  }


  async login(responseData: any) {
    sessionStorage.setItem('bearer_token', responseData.access_token);
    sessionStorage.setItem('expires_in', responseData.expires_in.toString());
  }

  async sessionLogin(responseData: any) {
    sessionStorage.setItem('session_token', responseData.access_token);
    sessionStorage.setItem('session_expires_in', responseData.expires_in.toString());
  }

  async storeHashcode(code: string) {
    sessionStorage.setItem('hashCode', code);
  }

  logout() {
    sessionStorage.removeItem('user_name');
    sessionStorage.removeItem('bearer_token');
    sessionStorage.removeItem('expires_in');
    sessionStorage.removeItem('session_token');
    sessionStorage.removeItem('session_expires_in');
    sessionStorage.removeItem('hashCode');
  }

  getUserName(): string {
    return sessionStorage.getItem('user_name');
  }

  setUserName(userName: string) {
    sessionStorage.setItem('user_name', userName);
  }

  loggedIn() {
    return !!sessionStorage.getItem('bearer_token');
  }

  getSessionToken() {
    return sessionStorage.getItem('bearer_token');
  }

  getHashCode() {
    return sessionStorage.getItem('hashCode');
  }

}
